/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Loading items using AJAX with multiple filter support

Supported functionality:

- Replacing all items (use case: switching category/filter)
- Appending items (use case: load more)
- Multiple intersecting filters

*/

import $ from 'jquery';

// Store active AJAX calls to cancel them when new filters are applied
let ajaxCalls = [];

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Initialize the app content filter and listen for the change event

*/

function initAjaxFilter(options) {
    // find and loop through filter containers
    $('.filter-container').each(function () {
        const $filter_container = $(this);
        const $plugin_container = $(this).parents('.app-content-plugin');

        // find all selects and add change listener
        $(this).find('select').each(function () {
            const initialized_attr = 'data-filter-initialized';
            if (typeof $(this).attr(initialized_attr) === 'undefined') {
                $(this).change((e) => {
                    // combined with categories?
                    const $category_container = $plugin_container.find('.app-content-categories');
                    if ($category_container.length > 0) {
                        const $active_category = $category_container.find('.active a');
                        loadAjaxItems($active_category, options);
                    }
                    // only filters: in this case, our filter-container is the trigger
                    else {
                        loadAjaxItems($filter_container, options);
                    }
                });
                $(this).attr(initialized_attr, '');
            }
        });
    });
}


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Initialize the filter reset button functionality

*/

function initAjaxFilterReset(options) {
    // find and loop through plugin containers
    $('.app-content-plugin').each(function () {
        const $plugin_container = $(this);
        const initialized_attr = 'data-reset-initialized';

        if (typeof $plugin_container.attr(initialized_attr) === 'undefined') {
            // Use event delegation on the plugin container to handle reset buttons
            $plugin_container.on('click', '[data-filter-reset-btn]', (e) => {
                e.preventDefault();
                const $filter_container = $plugin_container.find('.filter-container');

                // Reset all select elements to their first option
                $filter_container.find('select').each(function () {
                    $(this).val('').trigger('change.select2'); // trigger change for select2/selectpicker
                    $(this).selectpicker('refresh'); // refresh selectpicker
                });

                // ajax reload with cleared filters
                const $category_container = $plugin_container.find('.app-content-categories');
                if ($category_container.length > 0) {
                    const $active_category = $category_container.find('.active a');
                    loadAjaxItems($active_category, options);
                } else {
                    loadAjaxItems($filter_container, options);
                }
            });
            $plugin_container.attr(initialized_attr, '');
        }
    });
}


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Function that appends the filters values (= selected options) to the active category URL

*/

function appendFilterToURL(ajax_url, $filter_container) {
    $filter_container.find('select').each(function () {
        const selected_value = $(this).find('option:selected').val();
        if (selected_value) {
            // determine field name
            const field_name = $(this).attr('name');
            ajax_url += `&${field_name}=${selected_value}`;
        }
    });
    return ajax_url;
}


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Function that initializes ajax load item triggers

*/

export function initAjaxLoadItemsTrigger(options) {
    // initialize options
    var options = options || {};

    // find links and load items
    $('.ajax-load-items').each(function () {
        // init
        const $trigger = $(this);
        const initialized_attr = 'data-trigger-initialized';
        // check for initialized trigger
        const trigger_initialized = $trigger.attr(initialized_attr);
        // NOT initialized yet
        if (typeof trigger_initialized === 'undefined') {
            // add event listener
            $trigger.on('click', function (e) {
                // init
                const $trigger = $(this);
                // let me handle this ;)
                e.preventDefault();
                // special case 1: adios, when clicking on a category that is already active.
                if ($trigger.parent('li').hasClass('active')) {
                    return false;
                }
                // special case 2: the dynamic grid (masonry.js) handles appending items by itself
                if ($trigger.parents('.grid_dynamic-template').length > 0) {
                    return false;
                }
                // default

                loadAjaxItems($trigger, options);
            });
            // mark as initialized
            $trigger.attr(initialized_attr, '');
        }
    });

    // init the filter switch
    initAjaxFilter(options);

    // init the filter reset functionality
    initAjaxFilterReset(options);
}


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Function that loads the new or appended items

@param $trigger: The clicked link (either 'load more' or a 'category' in the category navigation)
@param options: Configuration options
@param (optional) masonry_grid: Vanilla JS Node item of the masonry grid
@param (optional) masonry_instance: Masonry Instance

*/

export function loadAjaxItems($trigger, options, masonry_grid, masonry_instance) {
    // initialize options
    var options = options || {};

    // init
    var masonry_grid = masonry_grid || null;
    var masonry_instance = masonry_instance || null;
    let ajax_url = $trigger.attr('href');
    const ajax_filter_base_url = $trigger.attr('data-ajax-filter-base-url');
    const insert_before_selector = $trigger.attr('data-insert-before-selector');
    const $plugin_container = $trigger.parents('.app-content-plugin');
    const $filter_container = $plugin_container.find('.filter-container');
    const $items_container = $plugin_container.find('.ajax-items-container');
    const $category_container = $trigger.parents('.app-content-categories');
    const $load_more_container = $plugin_container.find('.load-more-container');
    const $load_more_btn = $load_more_container.find('.btn-load-more');
    const category_active_class = 'active';
    const loading_class = 'loading';
    let append = false;
    const transtion_duration = options.ajax_load_transition_duration || 100;

    // Per default, we replace all items. But if an additional class '.append' is set on the trigger element, we obviously append items (load more)
    if ($trigger.hasClass('append')) {
        append = true;
    } else {
        $items_container.addClass(loading_class);
        $load_more_container.addClass(loading_class);
    }

    // are we browsing through the categories? if so, set active state
    if ($category_container.length > 0) {
        // remove all active classes
        $category_container.find('li').removeClass(category_active_class);
        // set active class on clicked element
        $trigger.parents('li').addClass(category_active_class);
    }

    // with disabled categories we don't get a href, which mean we get a base url from the filter-container
    if (typeof ajax_url === 'undefined') {
        ajax_url = ajax_filter_base_url;
    }

    // append filter values to URL
    ajax_url = appendFilterToURL(ajax_url, $filter_container);

    // cancel all previous registered ajax calls to prevent race conditions
    ajaxCalls.forEach((ajaxCall) => {
        ajaxCall.abort();
    });
    ajaxCalls = [];

    const ajaxCall = $.ajax({
        type: 'GET',
        url: ajax_url,
        contentType: 'application/json',
        success(data, textStatus, jqXHR) {
            // init
            let final_transition_duration = 0;

            // duration of CSS transition when EXCHANGING the content
            if (append === false) {
                final_transition_duration = transtion_duration;
            }

            // depending on the CSS transition settings, do stuff with or without delay
            setTimeout(() => {
                // toggle class on plugin container if the response contains the string 'no-results-container'
                if (data.no_results === true) {
                    $plugin_container.addClass('app-list__no-results');
                } else {
                    $plugin_container.removeClass('app-list__no-results');
                }

                // masonry grid: requires different appending technique
                if (masonry_instance !== null) {
                    getRenderedContent(masonry_grid, masonry_instance, data.rendered_content, append);
                }
                // default
                else {
                    // append
                    if (append === true) {
                        // insert before specific element
                        if (typeof insert_before_selector !== 'undefined') {
                            // init
                            const $insert_before_element = $plugin_container.find(`.${insert_before_selector}`);
                            $(data.rendered_content).insertBefore($insert_before_element);
                            $(window).trigger('ajaxLoadItems:appended');
                        }
                        // default ajax container
                        else {
                            $items_container.append(data.rendered_content);
                            $(window).trigger('ajaxLoadItems:appended', [$trigger, $plugin_container]);
                        }
                    }
                    // exchange entire content
                    else {
                        $items_container.html(data.rendered_content);
                        $(window).trigger('ajaxLoadItems:exchanged', [$trigger, $plugin_container]);
                    }
                }

                // init the filter reset functionality (must be called after content is in DOM)
                initAjaxFilterReset(options);

                // load more button: hide if there are no further pages
                if (!data.next_page_url || data.next_page_url === null) {
                    $load_more_container.hide();
                }
                // load more button: modify the link and make sure the button is shown
                else {
                    $load_more_container.show();
                    $load_more_btn.attr('href', data.next_page_url);
                }

                // trigger custom events
                $(window).trigger('ajaxLoadItems:success', [$trigger]);
                $(window).trigger('initSoftpageTrigger');
                $(window).trigger('initFormModalTrigger');
                $(window).trigger('initImageModalTrigger');
                $(window).trigger('initDefaultModalTrigger');
                $(window).trigger('btnAjaxLoaderDone');

                // remove loading class
                $items_container.removeClass(loading_class);
                $load_more_container.removeClass(loading_class);
            }, final_transition_duration);
        },
        error(xhr, status, error) {
            // Don't trigger error for aborted requests
            if (status !== 'abort') {
                const err = `(${xhr.responseText})`;
                $(window).trigger('ajaxLoadItems:error');
            }
            // remove loading class on error
            $items_container.removeClass(loading_class);
            $load_more_container.removeClass(loading_class);
        },
    });

    ajaxCalls.push(ajaxCall);
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Masonry (Grid Dynamic) exchanging/appending items

@param masonry_grid: Vanilla JS Node item of the masonry grid
@param masonry_instance: Masonry Instance
@param rendered_content: Items markup as a STRING
@param append: Boolean value, if we should append or exchange items

*/

function getRenderedContent(masonry_grid, masonry_instance, rendered_content, append) {
    // init
    const grid_items_array = [];
    let i = 0;
    const fragment = document.createDocumentFragment();

    // create and fill temporary container with our items markup
    const tmp_container = document.createElement('div');
    tmp_container.innerHTML = rendered_content;
    const tmp_grid_items = tmp_container.children;

    // fill our items array with the just created items
    for (const item of tmp_grid_items) {
        grid_items_array.push(item);
    }

    // add this markup to our fragment
    fragment.appendChild(tmp_container);

    // exchange items: remove all existing items first
    if (append === false) {
        const items_to_be_removed = masonry_grid.querySelectorAll('.grid-item');
        for (i = 0; i < items_to_be_removed.length; i++) {
            items_to_be_removed[i].remove();
        }
    }

    // append items
    masonry_grid.appendChild(fragment);
    masonry_instance.appended(grid_items_array);

    // Required delay: Redraw grid and re-calculate height
    setTimeout(() => {
        masonry_instance.layout();
    }, 10);
}


$(() => {
    const options = {
        ajax_load_transition_duration: 100,
    };

    // init on page load
    initAjaxLoadItemsTrigger(options);

    // re-init when softpage has been opened
    $(window).on('softpage:opened', () => {
        initAjaxLoadItemsTrigger(options);
    });

    // re-init after cms page refresh
    if (window.CMS) {
        CMS.$(window).on('cms-content-refresh', () => {
            initAjaxLoadItemsTrigger(options);
        });
    }
});
